class CommerceProductsTV {
    constructor() {
        this.tvs = document.querySelectorAll('.commerce-productstv');

        for (let i = 0; i < this.tvs.length; i++) {
            this.initTV(this.tvs[i]);
        }
    }

    initTV(dom) {
        const input = dom.querySelector('.commerce-productstv-value'),
            productList = dom.querySelector('.commerce-productstv-products'),
            maxProducts = parseInt(productList.getAttribute('data-max-products'));

        /**
         * Add the listener to the New Product button. On successful create, this will add the product to
         * the products grid automatically.
         * @type {Element}
         */
        let addProductBtn = dom.querySelector('.commerce-productstv-add-product');
        addProductBtn.addEventListener('click', function (e) {
            e.preventDefault();
            let opts = {};
            opts.successCallback = function (data) {
                if (data.record && data.record.id > 0) {
                    addProduct(data.record);
                    return true;
                }
                return false;
            };
            Commerce.Modal.openLoadingModal({
                title: addProductBtn.innerText.trim()
            });
            Commerce.Request.get(addProductBtn.getAttribute('href'), {
                onSuccess: function (response) {
                    Commerce.Modal.openModal(response, opts);
                }
            });
        });

        /**
         * Add the listener to the Link Existing Product button. This loads the product/link endpoint with the callback set
         * @type {Element}
         */
        let linkProductBtn = dom.querySelector('.commerce-productstv-find-product');
        linkProductBtn.addEventListener('click', function (e) {
            e.preventDefault();
            let opts = {};
            opts.successCallback = function (data) {
                if (data.id && data.id > 0) {
                    addProduct({
                        id: data.id,
                        name: 'Loading...'
                    });
                    return true;
                }
                return false;
            };

            Commerce.Modal.openLoadingModal();
            Commerce.Request.get(linkProductBtn.getAttribute('data-href'), {
                onSuccess: function (response) {
                    Commerce.Modal.openModal(response, opts);
                }
            });
        });

        dom.addEventListener('click', function (e) {
            /**
             * Add the listener to the Edit Product button to automatically refresh the product info on save
             */
            if (e.target.matches('.commerce-productstv-edit-product')) {
                if (event.ctrlKey || event.metaKey) {
                    return true;
                }
                e.preventDefault();
                let opts = {};
                opts.successCallback = function (data) {
                    if (data.success && data.record && data.record.id > 0) {
                        updateProductInfo(data.record.id);
                        return true;
                    }
                    return false;
                };

                Commerce.Modal.loadLinkModal.bind(Commerce.Modal)(e.target.getAttribute('href'), '', opts);
            }
            /**
             * Add the listener to the Unlink button which disconnects the product from the TV, while leaving it in place.
             */
            else if (e.target.matches('.commerce-productstv-unlink-product')) {
                e.preventDefault();
                let productRow = e.target.closest('.commerce-productstv-product'),
                    productId = productRow.getAttribute('data-product-id');
                unlinkProduct(productId);
            }
            /**
             * Add the listener to the Delete product to open the delete modal and remove it from the TV on success
             */
            else if (e.target.matches('.commerce-productstv-delete-product')) {
                e.preventDefault();
                let opts = {};
                opts.successCallback = function (data) {
                    if (data.record && data.record.id > 0) {
                        unlinkProduct(data.record.id);
                        return true;
                    }
                    return false;
                };

                Commerce.Modal.loadLinkModal.bind(Commerce.Modal)(e.target.getAttribute('href'), '', opts);
            }
        });

        /**
         * Instantiate Dragula for the drag & drop ordering
         */
        let drake = dragula([productList], {
            moves: function (el, container, handle) {
                return handle.classList.contains('commerce-productstv-product-sort-handle') || handle.parentNode.classList.contains('commerce-productstv-product-sort-handle');
            }
        });
        drake.on('drop', function() {
            // We use a timeout here to let dragula place it in the DOM first
            setTimeout(function() {
                let products = productList.querySelectorAll('.commerce-productstv-product'),
                    value = [];
                for (let i = 0; i < products.length; i++) {
                    value.push(products[i].getAttribute('data-product-id'));
                }
                value = value.join(',');
                input.value = value;
            }, 100);
        });


        /**
         * Make sure that on init the add/link buttons are hidden if we have too many products already
         */
        showOrHideAddButtons();
        function showOrHideAddButtons() {
            if (maxProducts > 0 && productList.children.length >= maxProducts) {
                addProductBtn.style.display = 'none';
                linkProductBtn.style.display = 'none';
            }
            else {
                addProductBtn.style.display = 'inline-block';
                linkProductBtn.style.display = 'inline-block';
            }
        }

        /**
         * Handle adding a product to both the UI and the hidden input. Provide an object with the id and name, the
         * rest will be retrieved via AJAX.
         * @param product
         */
        function addProduct(product) {
            let val = input.value,
                vals = val.length > 0 ? val.split(',') : [];

            if (vals.indexOf(product.id) === -1) {
                vals.push(product.id);
            }
            input.value = vals.join(',');

            let newProduct = document.createElement('li');
            newProduct.classList.add('commerce-productstv-product');
            newProduct.setAttribute('data-product-id', product.id);
            newProduct.innerHTML = '<header class="commerce-productstv-product-header"><i class="icon icon-refresh icon-spin"></i> ' + product.name + '</header>';
            productList.appendChild(newProduct);
            updateProductInfo(product.id);
            showOrHideAddButtons();
        }

        /**
         * Handle unlinking a product from the resource.
         * @param product
         */
        function unlinkProduct(product) {
            let val = input.value,
                vals = val.split(',');

            let index = vals.indexOf(product + "");
            if (index !== -1) {
                vals.splice(index, 1);
                let productListItem = dom.querySelectorAll('.commerce-productstv-product[data-product-id="' + product + '"]');
                for (let i = 0; i < productListItem.length; i++) {
                    // Previously we actually removed the list item, like so
                    //    productListItem[i].parentNode.removeChild(productListItem[i]);
                    // However, due to what might be an obscure Firefox 65 bug, that causes the resource save to fail with
                    // an not-very-useful error: uncaught exception: [object Object]
                    //
                    // Hiding the item visually has the drawback of not being able of expanding a re-linked item that
                    // was unlinked, but that's better than not being able of saving the resource at all.
                    //
                    productListItem[i].style.display = 'none';
                }
            }
            else {
                console.error('cannot find product to unlink', product, val, vals);
            }
            input.value = vals.join(',');
            showOrHideAddButtons();
        }

        /**
         * Update the product information for a specific product over AJAX.
         * @param id
         */
        function updateProductInfo(id) {
            Commerce.Request.get(Commerce.Config.connector_url + '?action=mgr/tvs/products/getproduct&product=' + id + '&wctx=' + Commerce.Config.wctx, {
                onSuccess: function (response) {
                    let responseDom = document.createElement('div');
                    responseDom.innerHTML = response;
                    let productListItem = dom.querySelectorAll('.commerce-productstv-product[data-product-id="' + id + '"]');
                    for (let i = 0; i < productListItem.length; i++) {
                        let checkbox = productListItem[i].querySelector('.commerce-productstv-toggle-checkbox'),
                            opened = checkbox ? checkbox.checked : false;
                        productListItem[i].innerHTML = responseDom.querySelector('.commerce-productstv-product').innerHTML;
                        if (opened) {
                            productListItem[i].querySelector('.commerce-productstv-toggle-checkbox').checked = true;
                        }
                    }
                }
            });
        }
    }
}
